import React, { useEffect, useReducer } from "react";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import useInfiniteScroll from "react-infinite-scroll-hook";
import useAxios from "axios-hooks";

import { ProjectCard, Spinner } from "../../components";
import Api from "../../api";

// import ProjectTh from "./ProjectTh";
import Filter from "./Filter";
import styles from "./projects.module.scss";

const filterReducer = (state, action) => {
  const defaultStatus = {
    projects: [],
    page: 1,
    hasNextPage: true,
  };

  switch (action.type) {
    case "set_projects":
      return {
        ...state,
        projects: [...state.projects, ...action.payload],
        page: state.page + 1,
        hasNextPage: action.payload.length > 0,
      };
    case "set_types":
      const hasInTypes = state.params.types.includes(action.payload);

      return {
        ...state,
        ...defaultStatus,
        params: {
          tags: [],
          customer: "",
          types: hasInTypes ? [] : [action.payload],
        },
      };
    case "set_tags":
      const hasInTags = state.params.tags.includes(action.payload);

      return {
        ...state,
        ...defaultStatus,
        params: {
          types: [],
          customer: "",
          tags: hasInTags ? [] : [action.payload],
        },
      };
    case "set_customer":
      return {
        ...state,
        ...defaultStatus,
        params: {
          types: [],
          tags: [],
          customer: action.payload,
        },
      };
    case "reset":
      return {
        ...state,
        ...defaultStatus,
        params: {
          types: [],
          customer: "",
          tags: [],
        },
      };
    default:
      throw new Error(`Uncorrect action type: ${action.type}`);
  }
};

const Projects = ({ }) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get("customer");
  const queryTypeProjects = searchParams.get("type");
  const queryTagProjects = searchParams.get("tag");

  const [state, dispatch] = useReducer(filterReducer, {
    projects: [],
    page: 1,
    hasNextPage: true,
    params: { types: [], tags: [], customer: "" },
  });

  const [{ loading, error }, request] = useAxios({
    url: Api.projects.replace(":page", state.page),
    params: state.params,
  });

  const fetchProjects = () => {
    request()
      .then((data) => {
        const newProjects = data.data.projects || [];

        dispatch({ type: "set_projects", payload: newProjects });
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: state.hasNextPage,
    onLoadMore: fetchProjects,
    disabled: !!error,
    rootMargin: "0px 0px 400px 0px",
  });

  const setUrlParams = (query, param) => {
    if (param.length === 0) {
      // Удаляем параметры при сбросе фильтра
      const newUrl = window.location.pathname;
      
      window.history.pushState({}, '', newUrl);

      // setSearchParams({ });

      return;
    }
  
    // setSearchParams({ query: param });

    const urlParams = new URLSearchParams();

    urlParams.set(query, param);

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, '', newUrl);
  }

  const setTypes = (type) => {
    dispatch({ type: "set_types", payload: type });

    setUrlParams("type", type);
  };

  const setTags = (tag) => {
    dispatch({ type: "set_tags", payload: tag });

    setUrlParams("tag", tag);
  };

  const reset = () => {
    dispatch({ type: "reset" });

    setUrlParams("", "");
  };

  useEffect(() => {
    fetchProjects();
  }, [state.params]);

  useEffect(
    function fetchCustomerProjects() {
      if (customerId) {
        dispatch({ type: "set_customer", payload: customerId });
      }
    },
    [customerId]
  );

  useEffect(
    function fetchQueryProjects() {
      if (queryTypeProjects) {
        dispatch({ type: "set_types", payload: queryTypeProjects });
      } else if (queryTagProjects) {
        dispatch({ type: "set_tags", payload: queryTagProjects });
      }
    },
    [queryTagProjects, queryTypeProjects]
  );

  return (
    <div className={classNames("app", styles.Container)}>
      <div className="wrap holder no-pdn-top">
        <Filter
          activeTypes={state.params.types}
          activeTags={state.params.tags}
          setTypes={setTypes}
          setTags={setTags}
          reset={reset}
        />

        <div className={classNames(styles.ProjectsList, loading && styles.SmallMargin)}>
          {state.projects.map((project) => {
            if (project.hided) {
              return null;
            }

            return <ProjectCard key={project.id} item={project} />;
          })}
        </div>

        <div ref={sentryRef}></div>

        {!!loading && (
          <div className={styles.Loading}>
            <Spinner />
          </div>
        )}

        {!!error && <div>Упс! Что-то пошло не так. Зайдите позже.</div>}
      </div>
    </div>
  );
};

export default Projects;
